import React, { useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { ErrMessage, MinLoader } from 'components';
import { Images, KeyPurpose } from 'utils';
import { uploadFileWithPreview } from 'store';
import { UploadedSignature } from '../../../../../fragments/schedule/core/common/uploadedSignature';
import { ResizableImage } from './resizableImage';
import { useFormBuilder } from '../../formContext';

export const UploadFileSignature = ({ item, value, onChange, readOnly, width, blockWidth }) => {
    const [uploadLoader, setUploadLoader] = useState(false);
    const { onDragStart, setOnDragStart } = useFormBuilder();
    const handleUploadFile = async (file, name) => {
        // See uploadFileWithPreview docstring for blob-URL lifecycle.
        const { previewUrl, storedFile } = uploadFileWithPreview(file, KeyPurpose.CLINICAL_DOC);
        onChange({
            url: previewUrl,
            originalName: file.name,
            format: (file.name.split('.').pop() || '').toLowerCase(),
        });
        setUploadLoader(true);
        try {
            onChange({ ...(await storedFile), url: previewUrl });
        } catch (e) {
            onChange(null);
            throw e;
        } finally {
            setUploadLoader(false);
        }
    };

    const fileValue = item?.value;
    const isImage =
        fileValue &&
        /\.(svg|jpe?g|png|gif|webp|bmp)$/i.test(
            typeof fileValue === 'string'
                ? fileValue
                : fileValue?.url || fileValue?.originalName || fileValue?.name || ''
        );
    if (isImage) {
        return (
            <div className="builder-uploaded-image" style={{ padding: '0 2px 8px' }}>
                <div className="space-between" style={{ width: '100%', justifyContent: 'space-between', marginBottom: 12 }}>
                    <p className="preview-creator-info-line-title" style={{ marginBottom: 0 }}>
                        {''}
                    </p>
                    {!readOnly ? (
                        <button
                            onClick={() => {
                                onChange(null);
                            }}
                            className="reset-btn-by-default"
                        >
                            <img src={Images.redTrash} alt="redTrash" />
                        </button>
                    ) : (
                        <div />
                    )}
                </div>
                <div onMouseEnter={() => !onDragStart && setOnDragStart(true)} onMouseLeave={() => onDragStart && setOnDragStart(false)}>
                    <ResizableImage
                        src={fileValue?.url}
                        alt={'uploaded-image'}
                        style={{ maxHeight: 300 }}
                        initialWidth={fileValue?.resizedWidth}
                        initialHeight={fileValue?.resizedHeight}
                        onResize={({ width, height }) => {
                            onChange({
                                ...fileValue,
                                resizedWidth: width,
                                resizedHeight: height,
                            });
                        }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="flex-justify-align-center">
            <div style={{ width: width ? width : 550 }}>
                <FileUploader
                    handleChange={(file) => {
                        if (!readOnly) handleUploadFile(file, item?.name);
                    }}
                    name={item?.name}
                    disabled={readOnly}
                >
                    <div className="drag-drop-component" style={{ opacity: readOnly ? 0.6 : 1, pointerEvents: readOnly ? 'none' : 'auto' }}>
                        <div style={{ height: 50 }}>
                            {uploadLoader ? (
                                <MinLoader
                                    margin={'0'}
                                    width={'36px'}
                                    height={'36px'}
                                    color={'#475467'}
                                    position={'relative'}
                                    style={{ marginBottom: 12 }}
                                />
                            ) : (
                                <img src={Images.uploadCloudBlack} alt="icon" />
                            )}
                        </div>

                        <label className="custom-file-upload">
                            <input
                                onClick={(event) => (event.target.value = null)}
                                onChange={(file) => {
                                    if (!readOnly) handleUploadFile(file, item?.name);
                                }}
                                type="file"
                                name={item?.name}
                                id="file"
                                disabled={readOnly}
                            />
                            <i className="fa fa-cloud-upload" />
                            <div className="upload">
                                <p>
                                    <span style={{ color: '#2E6DD8', fontWeight: 600 }}>Click to upload</span> or drag and drop
                                </p>
                                <p style={{ fontSize: '12px', color: '#172B4D' }}>PDF, PNG, JPG and CSV (max. 800x400px)</p>
                            </div>
                        </label>
                    </div>
                </FileUploader>
                <ErrMessage text={''} />
                {item?.value && (
                    <UploadedSignature
                        textWidth={blockWidth === 'calc(50% - 6px)' ? 170 : 330}
                        handleRemoveUploaded={() => onChange(null)}
                        alreadyUploaded={true}
                        currentFile={{ file: item?.value }}
                        alwaysDelete={true}
                        noDel={readOnly}
                    />
                )}
            </div>
        </div>
    );
};
